/** Ported from Clarity `apps/web/src/shared/types/workspaceRoute.ts` (commit `f9217bb5a`). */
/**
 * Every tab segment Clarity's workspace URL accepts — brain's `DASHBOARD_TABS`, in brain's order.
 *
 * This is **brain's** list, not the Control Center's strip: `site` and `assistant` are here although
 * no Efficiently tab answers them, because the ported URL rules validate a `:tab` segment against
 * exactly this list — anything else is canonicalised to `pulse` — and a narrower list would rewrite URLs
 * brain leaves alone.
 */
export const CLARITY_DASHBOARD_TABS = [
	'pulse',
	'open-items',
	'site',
	'meetings',
	'email',
	'calendar',
	'documents',
	'canvas',
	'assistant',
] as const;

/** One of {@link CLARITY_DASHBOARD_TABS} — derived from the list, never written by hand. */
export type ClarityDashboardTab = (typeof CLARITY_DASHBOARD_TABS)[number];
